<template>
  <div id="app">
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer';

export default {
  components: {
    Footer,
  },
};
</script>

<style lang="scss">
#app {
  font-family: $--font--primary;
  overflow: hidden;
}
</style>
